"use strict";

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _uniqid = _interopRequireDefault(require("uniqid"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var _Canvas = _interopRequireDefault(require("./Canvas"));

var _SettingsPanel = _interopRequireDefault(require("./settings/SettingsPanel"));

var _settings = require("../constants/settings");

var _CurrentContext = _interopRequireDefault(require("./context/CurrentContext"));

var _OrderContext = _interopRequireDefault(require("./context/OrderContext"));

var _AnchorsEditableContext = _interopRequireDefault(require("./context/AnchorsEditableContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 15px;\n    border: 1px solid #eee;\n    width: ", "px;\n    height: ", "px;\n    overflow: hidden;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    * {\n        box-sizing: border-box;\n    }\n    font-family: 'Lucida Grande', sans-serif;\n    display: inline-flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents.default.div(_templateObject());

var CanvasWrapper = _styledComponents.default.div(_templateObject2(), (0, _ramda.prop)('width'), (0, _ramda.prop)('height'));

var Wrapper = _styledComponents.default.div(_templateObject3());

var Designer =
/*#__PURE__*/
function (_Component) {
  _inherits(Designer, _Component);

  function Designer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Designer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Designer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selectedType: null,
      current: null,
      anchorsEditable: false,
      currentAnchor: null
    };

    _this.onKeyDown = function (e) {
      var _this$state = _this.state,
          current = _this$state.current,
          currentAnchor = _this$state.currentAnchor;

      if ((0, _ramda.contains)(e.target.tagName, ['TEXTAREA', 'INPUT'])) {
        return;
      }

      switch (e.keyCode) {
        case 8:
          if (currentAnchor) {
            _this.onRemoveCurrentAnchor();
          } else if (current) {
            _this.onRemoveCurrent();
          }

          break;

        case 37:
          _this.moveCurrentToX(e, true);

          break;

        case 38:
          _this.moveCurrentToY(e, true);

          break;

        case 39:
          _this.moveCurrentToX(e);

          break;

        case 40:
          _this.moveCurrentToY(e);

          break;

        default:
      }
    };

    _this.moveCurrentToX = function (e, left) {
      e.preventDefault();

      var current = _this.getCurrentElement();

      if (current) {
        var x = current.x + (left ? -1 : 1);

        _this.onChangeCurrentElement(_objectSpread({}, current, {
          x: x
        }, current.anchors ? {
          anchors: current.anchors.map(function (a) {
            return (0, _ramda.assoc)('x', a.x + (left ? -1 : 1), a);
          })
        } : {}));
      }
    };

    _this.moveCurrentToY = function (e, top) {
      e.preventDefault();

      var current = _this.getCurrentElement();

      var y = current.y + (top ? -1 : 1);

      _this.onChangeCurrentElement(_objectSpread({}, current, {
        y: y
      }, current.anchors ? {
        anchors: current.anchors.map(function (a) {
          return (0, _ramda.assoc)('y', a.y + (top ? -1 : 1), a);
        })
      } : {}));
    };

    _this.onSelectType = function (selectedType) {
      return _this.setState({
        selectedType: selectedType,
        current: null,
        anchorsEditable: false,
        currentAnchor: null
      });
    };

    _this.onChangeCurrent = function (current) {
      return _this.setState(function (prev) {
        var allowResetAnchors = current && prev.current === current;
        return {
          current: current,
          anchorsEditable: allowResetAnchors ? prev.anchorsEditable : false,
          currentAnchor: allowResetAnchors ? prev.currentAnchor : null
        };
      });
    };

    _this.onChangeAnchorsEditable = function (anchorsEditable) {
      return _this.setState({
        anchorsEditable: anchorsEditable
      });
    };

    _this.getElements = function () {
      return (0, _ramda.pathOr)([], ['data', 'elements'], _this.props);
    };

    _this.getSettings = function () {
      return (0, _ramda.pathOr)({}, ['data', 'settings'], _this.props);
    };

    _this.getCurrentElement = function () {
      var current = _this.state.current;
      return (0, _ramda.find)((0, _ramda.propEq)('name', current), _this.getElements());
    };

    _this.onChangeElements = function (elements) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          data = _this$props.data;
      onChange(_objectSpread({}, data, {
        elements: elements
      }));
    };

    _this.onChangeSettings = function (settings) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          data = _this$props2.data;
      onChange(_objectSpread({}, data, {
        settings: settings
      }));
    };

    _this.onAddElement = function (x, y) {
      var selectedType = _this.state.selectedType;
      var name = (0, _uniqid.default)();
      var defaultSettings = _settings.DEFAULT_SETTINGS[selectedType];

      _this.onChangeElements([].concat(_toConsumableArray(_this.getElements()), [_objectSpread({}, defaultSettings, {
        name: name,
        x: x,
        y: y
      }, defaultSettings.anchors ? {
        anchors: [{
          x: x,
          y: y,
          bezier: false
        }]
      } : {})]));

      _this.setState({
        selectedType: null,
        current: name,
        anchorsEditable: !!defaultSettings.anchors,
        currentAnchor: defaultSettings.anchors ? {
          name: name,
          index: 0
        } : null
      });
    };

    _this.onChangeCurrentElement = function (element) {
      var elements = _this.getElements();

      _this.onChangeElements((0, _ramda.update)((0, _ramda.findIndex)((0, _ramda.propEq)('name', element.name), elements), element, elements));
    };

    _this.onChangeCurrentProp = function (prop, value) {
      var element = _objectSpread({}, _this.getCurrentElement(), _defineProperty({}, prop, value));

      _this.onChangeCurrentElement(element);
    };

    _this.onChangeSettingsProp = function (prop, value) {
      var settings = _objectSpread({}, _this.getSettings(), _defineProperty({}, prop, value));

      _this.onChangeSettings(settings);
    };

    _this.onRemoveCurrent = function () {
      var current = _this.state.current;

      var elements = _this.getElements();

      _this.onChangeElements((0, _ramda.remove)((0, _ramda.findIndex)((0, _ramda.propEq)('name', current), elements), 1, elements));

      _this.setState({
        current: null,
        anchorsEditable: false,
        currentAnchor: null
      });
    };

    _this.onChangeOrder = function (back, once) {
      var current = _this.state.current;

      var elements = _this.getElements();

      var startIndex = (0, _ramda.findIndex)((0, _ramda.propEq)('name', current), elements);
      var endIndex = once ? back ? startIndex - 1 < 0 ? 0 : startIndex - 1 : startIndex + 1 > elements.length ? elements.length : startIndex + 1 : back ? 0 : elements.length;
      var result = Array.from(elements);

      var _result$splice = result.splice(startIndex, 1),
          _result$splice2 = _slicedToArray(_result$splice, 1),
          removed = _result$splice2[0];

      result.splice(endIndex, 0, removed);

      _this.onChangeElements(result);
    };

    _this.onAddAnchor = function (x, y) {
      var current = _this.getCurrentElement();

      var anchors = [].concat(_toConsumableArray(current.anchors), [{
        x: x,
        y: y,
        bezier: false
      }]);

      _this.onChangeCurrentProp('anchors', anchors);

      _this.setState({
        currentAnchor: {
          name: current.name,
          index: anchors.length - 1
        }
      });
    };

    _this.onChangeCurrentAnchor = function (name, index) {
      return _this.setState({
        currentAnchor: {
          name: name,
          index: index
        }
      });
    };

    _this.onRemoveCurrentAnchor = function () {
      var currentAnchor = _this.state.currentAnchor;

      var current = _this.getCurrentElement();

      _this.setState({
        currentAnchor: null
      });

      _this.onChangeCurrentProp('anchors', (0, _ramda.remove)(currentAnchor.index, 1, current.anchors));
    };

    _this.detachElement = function () {
      if (_this.transformer) {
        _this.transformer.detach();

        _this.transformer.getLayer().batchDraw();
      }
    };

    return _this;
  }

  _createClass(Designer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          width = _this$props3.width,
          height = _this$props3.height,
          getStageRef = _this$props3.getStageRef,
          postFileUrl = _this$props3.postFileUrl,
          getFileUrl = _this$props3.getFileUrl;
      var _this$state2 = this.state,
          selectedType = _this$state2.selectedType,
          anchorsEditable = _this$state2.anchorsEditable,
          currentAnchor = _this$state2.currentAnchor;
      var elements = this.getElements();
      var currentElement = this.getCurrentElement();
      return _react.default.createElement(Wrapper, null, _react.default.createElement(_reactClickOutside.default, {
        onClickOutside: this.detachElement
      }, _react.default.createElement(_CurrentContext.default.Provider, {
        value: {
          current: currentElement,
          onChangeProp: this.onChangeCurrentProp,
          onChange: this.onChangeCurrentElement,
          onRemove: this.onRemoveCurrent,
          settings: this.getSettings(),
          onChangeSettingsProp: this.onChangeSettingsProp,
          onChangeSettings: this.onChangeSettings
        }
      }, _react.default.createElement(_OrderContext.default.Provider, {
        value: {
          onChangeOrder: this.onChangeOrder
        }
      }, _react.default.createElement(Container, null, _react.default.createElement(_Toolbar.default, {
        selected: selectedType,
        onSelect: this.onSelectType
      }), _react.default.createElement(CanvasWrapper, {
        width: width,
        height: height
      }, _react.default.createElement(_Canvas.default, {
        elements: elements,
        current: currentElement,
        onChangeCurrentElement: this.onChangeCurrentElement,
        onChangeCurrentProp: this.onChangeCurrentProp,
        selectedType: selectedType,
        onChangeCurrent: this.onChangeCurrent,
        onAddElement: this.onAddElement,
        onAddAnchor: this.onAddAnchor,
        onChangeCurrentAnchor: this.onChangeCurrentAnchor,
        currentAnchor: currentAnchor,
        width: width,
        height: height,
        settings: this.getSettings(),
        anchorsEditable: anchorsEditable,
        getTransformerRef: function getTransformerRef(node) {
          return _this2.transformer = node;
        },
        getStageRef: getStageRef,
        getFileUrl: getFileUrl
      })), _react.default.createElement(_AnchorsEditableContext.default.Provider, {
        value: {
          editable: anchorsEditable,
          onChangeEditable: this.onChangeAnchorsEditable,
          onRemoveCurrentAnchor: this.onRemoveCurrentAnchor,
          currentAnchor: currentAnchor
        }
      }, _react.default.createElement(_SettingsPanel.default, {
        type: (0, _ramda.path)(['type'], currentElement),
        postFileUrl: postFileUrl
      })))))));
    }
  }]);

  return Designer;
}(_react.Component);

exports.default = Designer;
Designer.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  data: _propTypes.default.shape({
    elements: _propTypes.default.arrayOf(_propTypes.default.object),
    settings: _propTypes.default.object
  }),
  getStageRef: _propTypes.default.func,
  postFileUrl: _propTypes.default.string,
  getFileUrl: _propTypes.default.func
};
Designer.defaultProps = {
  data: {},
  width: _settings.WIDTH,
  height: _settings.HEIGHT,
  getFileUrl: function getFileUrl() {
    return 'https://c.radikal.ru/c23/2103/dd/85835c23f0be.png';
  }
};